import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Heart, LayoutDashboard, Users, Flag, CreditCard, ShieldCheck, LogOut, ArrowLeft } from "lucide-react";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/reports", label: "Reports", icon: Flag },
  { to: "/admin/payments", label: "Payments", icon: CreditCard },
  { to: "/admin/moderation", label: "Moderation", icon: ShieldCheck },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen grain flex flex-col md:flex-row">
      <aside className="md:w-64 bg-black text-white md:min-h-screen p-4 md:sticky md:top-0 md:h-screen flex md:flex-col gap-2 overflow-x-auto">
        <Link to="/admin" className="flex items-center gap-2 px-2 py-3 mb-2">
          <div className="bg-[#8B1E3F] nb-border p-1.5"><Heart className="w-5 h-5 text-white" fill="white" /></div>
          <span className="font-head font-black text-xl">qrcupid<span className="text-[#D4AF37]">.admin</span></span>
        </Link>
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase()}`}
            className={({ isActive }) => `flex items-center gap-2 px-3 py-2 font-head font-bold uppercase text-sm whitespace-nowrap ${isActive ? "bg-[#8B1E3F] nb-border" : "hover:bg-white/10"}`}>
            <l.icon className="w-4 h-4" /> {l.label}
          </NavLink>
        ))}
        <div className="md:mt-auto flex md:flex-col gap-2">
          <Link to="/dashboard" className="flex items-center gap-2 px-3 py-2 font-head font-bold uppercase text-sm hover:bg-white/10 whitespace-nowrap"><ArrowLeft className="w-4 h-4" /> Member Area</Link>
          <button onClick={logout} className="flex items-center gap-2 px-3 py-2 font-head font-bold uppercase text-sm hover:bg-white/10 whitespace-nowrap"><LogOut className="w-4 h-4" /> Logout</button>
        </div>
      </aside>
      <main className="flex-1 p-4 sm:p-8 overflow-x-auto"><Outlet /></main>
    </div>
  );
}
